import { getCountryAndLanguage } from './localization';
import { loadTokenService } from './tokenService';

// Run global script that fetches token and stores it as cookie.
export async function fetchAuthToken(): Promise<string> {
  if (['development', 'test'].includes(process.env.NODE_ENV) && !window.ikea?.authentication) {
    const { countryCode, languageCode } = getCountryAndLanguage();
    await loadTokenService(countryCode.toLowerCase(), languageCode.toLowerCase());
  }

  return new Promise((resolve, reject) => {
    if (!window.ikea?.authentication) {
      return reject(new Error('window.ikea.authentication is missing'));
    }

    window.ikea.authentication.getTokens((error, tokens) => {
      if (error) {
        return reject(error);
      } else {
        const { guest, auth } = tokens;

        if (auth) {
          return resolve(auth.value);
        } else if (guest) {
          return resolve(guest.value);
        }

        return reject(new Error('Could not get either guest or auth token from token-service'));
      }
    });
  });
}
